
export const networkManagementConstants={
    exportVbc:{
      programVbcDef:{
        MAPCPI: 'Medicare Advantage Primary Care Physician Incentive',
        MCAIP: 'Medical Condition Assessment Incentive Program',
        PBC: 'Performance Based Programs',
        ACO: 'Accountable Care Program',
        HPBC: 'Hospital Performance Based Program',
        PPBC: 'Physician Performance Based Program',
        ACSS_BCR: 'Accountable Care Shared Savings BCR (Benefit Cost Ratio)',
        ACSS_CE: 'Accountable Care Shared Savings CE (Clinical Efficiency)',
        ACSS_PMPM: 'Accountable Care Shared Savings PMPM (Per Member Per Month)',
        CIP: 'Clinical Integration Only',
        PCMH: 'Patient Centered Medical Home',
        PED: 'Pediatric Model',
        PMPM_BQM: 'Accountable Care Shared Savings w/ Basic Quality',
        QSS_BCR: 'Quality Shared Savings BCR (Benefit Cost Ratio)',
        QSS_CE: 'Quality Shared Savings CE (Clinical Efficiency)',
        QSS_PMPM: 'Quality Shared Savings PMPM (Per Member Per Month)',
        'ACO C&S': 'Accountable Care Program C&S',
        'N/A': 'N/A',
        'Accountable Care Shared Savings BCR': 'Accountable Care Shared Savings BCR (Benefit Cost Ratio)',
        'Accountable Care Shared Savings PMPM': 'Accountable Care Shared Savings PMPM (Per Member Per Month)',
    },
    lobMapping: {
        'All': 'All',
        'E&I': 'Ei',
        'M&R': 'Mr',
        'C&S': 'Cs'
    },
    NA: 'N/A',
    taxID: 'Tax ID',
    taxIdName: 'Tax Id Name',
    contractOriginDate: 'Contract Origin Date',
    currentProgramTimeframe: 'Current Program Timeframe',
    programName: 'Program Name',
    subProgramName: 'Sub Program Name',
    activePrograms: 'Active Programs',
    twentyTwentyThree: '2023',
    vbcActivePrograms: 'VBC Active Programs',
    valueBasedContracting: 'Value Based Contracting',
    activeProgramsForIncentiveYear: 'Active Programs for Incentive Year',
    errorFechingVbcProgramDetails: 'Error fetching VBA program details:',
    inavalidSessionState: 'Invalid session state',
    lob: 'LOB',
    LobSentence: "Lob"
  }
}